import React from 'react';
import PropTypes from 'prop-types';
import conversationStatuses from 'enums/conversationStatuses';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Form from 'form/Form';
import { TextField } from 'mui-rff';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

const ChangeStatusDialog = ({ conversation, open, onSubmit, onCancel }) => {
    const initialValues = {
        status: conversation.status
    };

    return (
        <Dialog maxWidth="md" fullWidth open={open} onClose={onCancel}>
            <Form
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                    <DialogTitle disableTypography>
                        <Typography variant="h5">
                            Change status for conversation
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                select
                                name="status"
                                label="Status"
                                variant="outlined"
                            >
                                {
                                    Object.values(conversationStatuses).map(o => (
                                        <MenuItem key={o.key} value={o.key}>
                                            {o.title}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Save
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Form>
        </Dialog>
    );
};

ChangeStatusDialog.propTypes = {
    conversation: PropTypes.object.isRequired,
    open: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default ChangeStatusDialog;
